import { eventBus } from '@eventBus'
import { mapActions } from 'vuex'
import log from '../../components/Telephony/v2/js/customLog.js'

export default {
    data() {
        return {
            timer: false,
            channel: null,
            isJanus: false,
            tabs: [],
            currentTab: null,
        }
    },
    mounted() {
        this.console = new log({name: 'tabs', info: 'background: #0cc; color: #000; font-weight: 900; padding:5px'})
        
        eventBus.$on('globalMakeCall', this.tabMakeCall);
        eventBus.$on('companyisChanget', this.tabChangeCompanyEmit);
        this.channel = new BroadcastChannel('tabchanel');
        const tab = this.createTab()
        this.currentTab = tab

        this.console.log('Запрашиваю вкладки');
        this.channel.postMessage({ type: 'requestTabs', tab: this.currentTab });

        this.timer = setTimeout(() => {
            if (!this.tabs.length) {
                this.console.log('Похоже, это первая вкладка — запускаем Janus');
                this.tabInitJanus();
                this.setIntevalPing()
            } else {
                
                this.console.log('Janus уже есть в другой вкладке');
                
                this.saveTab(this.currentTab);
                
                const masterJanus = this.tabs.find(e=>e.isJanus)
                if(masterJanus && masterJanus.isJanus == 'error') {
                   // this.telHidde = true
                }
                this.textError = 'уже есть';
            }
        }, 800);
        
        this.channel.onmessage = (event) => {
            const data = event.data;
            if(data?.type != 'ping') this.console.log('tabs onmessage:',data);
            switch (data.type) {
                case 'addNewTab':
                    this.handleAddNewTab(data);
                    break;
                case 'checkTabs':
                    this.checkTabsResponse();
                    break;
                case 'responceTab':
                    this.handleResponceOtherTabs(data)
                    break;
                case 'tabClose':
                    this.handleTabClose(data);
                    break;
                case 'startJanus':
                    this.otherTabStartJanus(data)
                    break;
                case 'tabMakeCall':
                    this.tabMakeCall(data)
                    break;
                case 'changeCompany':
                    this.tabChangeCompany(data)
                    break;
                case 'requestTabs':
                    this.handleRequestTabs(data);
                    break;
                case 'responseTabs':
                this.handleResponseTabs(data);
                    break;

                case 'ping':
                    this.makePing()
                    break;
            }
        };
        const _this = this
        window.addEventListener('unload', function (event) {
            _this.channel.postMessage({ type: 'tabClose', tab: _this.currentTab });
            _this.removeFromTabsd(_this.currentTab)
            this.console.log('channel.postMessage tabClose')
        });
        
        document.addEventListener("visibilitychange", function() {
            if (!document.hidden) {
                this.setIntevalPing()
            } else { 
                clearInterval(this.interval)
            }
        }.bind(this));
    },
    methods: {
        ...mapActions([
            'GET_TABS',
            'SET_TABS'
        ]),
        callPing() {
            if(this.currentTab.isJanus) this.makePing()
            this.channel.postMessage({ type: 'ping', tab: this.currentTab });
            //this.console.log('channel.postMessage ping')
        },

        tabsHasJanus() {
            return this.tabs.length && this.tabs.some(tab => tab.isJanus)
        },

        tabInitJanus() {
            this.console.log('Janus запускается', {length:this.tabs.length, tabs: this.tabs});
            this.channel.postMessage({ type: 'startJanus', tab: this.currentTab });
            this.telloading = true
            this.initTel().then(response=>{
                this.currentTab.isJanus = true
                this.saveTab(this.currentTab)
            }).catch(error=>{
                this.currentTab.isJanus = 'error'
                this.saveTab(this.currentTab)
                this.textError = error.msg
            })
        },
        handleAddNewTab(data) {
            this.console.log('tabs:','Новая вкладка', data.tab);
            this.saveTab(data.tab)
            this.channel.postMessage({ type: 'responceTab', tab: this.currentTab });
            this.console.log('channel.postMessage responceTab') 
        },
        handleTabClose(data) {
            this.console.log('tabs:','закрытая владка', data.tab);
            this.removeFromTabsd(data.tab)
            const tabs = this.tabs
            if(data.tab.isJanus && (!tabs.length ||  tabs[0].id >= this.currentTab.id)) {
                this.tabInitJanus()
            }
        },
        handleResponceOtherTabs(data) {
            if(this.timer) clearTimeout(this.timer)
            this.saveTab(data.tab)
            
        },
        handleRequestTabs(data) {
            this.console.log('Получен запрос на список вкладок от', data.tab);
            this.channel.postMessage({
                type: 'responseTabs',
                tabs: this.tabs
            });

            this.console.log('Отправлен список вкладок:', this.tabs);
        },
        handleResponseTabs(data) {
            this.console.log('Получен список вкладок от другой вкладки:', data.tabs);
            data.tabs.forEach(tab => {
                if (!this.tabs.some(t => t.id === tab.id)) {
                    this.tabs.push(tab);
                }
            });
        },
        createTab() {
            return {
                id: new Date().getTime(),
                isJanus: null,
            }
        },
        removeFromTabsd(tab) {
            const index = this.tabs.findIndex(_tab => _tab.id === tab.id);
            if (index > -1) {
                this.tabs.splice(index, 1);
            }
            this.console.log('tabs:',this.tabs);
        },
        saveTab(newtab) {
            const exist = this.tabs.some(tab => tab.id === newtab.id);
            if (!exist) {
                this.tabs.push(newtab);
            }
            this.telloading = false
            this.console.log('tabs:',this.tabs);
            
        },
        otherTabStartJanus(data) {
            this.tabsChangeJanusStatus(data.tab)
        },
        tabsChangeJanusStatus(tab) {
            const tabFromList = this.tabs.find(_tab=>_tab.id === tab.id)
            if(!tabFromList) return
            tabFromList.isJanus = tabFromList.isJanus
            this.console.log('tabFromList',this.tabs,tabFromList);
        },

        tabChangeCompanyEmit(data)  {
            this.channel.postMessage({ type: 'changeCompany', tab: this.currentTab });  
            this.console.log('channel.postMessage changeCompany') 
        },

        tabChangeCompany() {
            this.$store.dispatch('AUTH_REFRESH')
            eventBus.$emit('softRefresh')
        },


        tabMakeCall(data) {
            if(this.currentTab.isJanus) {
                this.handleTabCalling(data);
                return
            } else if(!data.tab || this.currentTab.id == data.tab.id) {
                this.channel.postMessage({ type: 'tabMakeCall', phoneNumber:data.phoneNumber, dump_id: data.dump_id, tab: this.currentTab });
                this.console.log('channel.postMessage tabMakeCall') 
                return
            }
        },


        PostNewTab() {
            this.channel.postMessage({ type: 'checkTabsResponse', id: this.currentTab.tab_id });
            this.console.log('channel.postMessage checkTabsResponse') 
        },
        checkTabsResponse() {
            this.channel.postMessage({ type: 'responceTab', tab: this.currentTab });
            this.console.log('channel.postMessage responceTab') 
        },

        makePing() {
            if(this.currentTab.isJanus) {
                this.makeSocketPing()
            }  
        },

        setIntevalPing() {
            if(this.interval) clearInterval(this.interval)
            this.interval = setInterval(this.callPing, 1000)
        },
        
    }
}
